import { CodeOutlined, UserOutlined } from "@ant-design/icons";
import { Space } from "antd";
import * as React from "react";
import {
  ZWorkflowStepType,
  zWorkflowStepType,
} from "src/business/workflow/ZWorkflowStep";

const stepTypes = {
  [zWorkflowStepType.enum.user]: {
    label: "Пользовательский",
    icon: <UserOutlined />,
  },
  [zWorkflowStepType.enum.system]: {
    label: "Системный",
    icon: <CodeOutlined />,
  },
} satisfies Record<
  NonNullable<ZWorkflowStepType>,
  { label: string; icon: React.ReactNode }
>;

export const stepTypeMap = new Map<ZWorkflowStepType, string>(
  zWorkflowStepType.options.map((type) => [type, stepTypes[type].label]),
);

export const stepTypeOptions = Object.entries(stepTypes).map(
  ([value, { label, icon }]) => ({
    value,
    label: (
      <Space size={8}>
        {icon}
        {label}
      </Space>
    ),
  }),
);
